import * as actionTypes from "./actionTypes";
import * as actions from './index';
import * as CropTypes from 'Flow2/components/Crop/CropTypes/CropTypes';
import { showIntlConfirmDialogWithCallback } from "Flow2/components/CustomCollections/CustomDataUtil/CustomDataUtil";

export const updateCropObjects = (obj) => {
    return (dispatch) => {
        dispatch(actions.updateCropObjectsSuccess(obj));
    }
}

export const updateCropObjectsStart = () => {
    return {
        type: actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_START,
    }
}

export const setInitCropObjects = () => {
    return {
        type: actionTypes.CROPIMAGE_SET_INIT_CROPOBJECTS
    }
}

export const updateCropObjectsSuccess = (data) => {
    return {
        type: actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_SUCCESS,
        payload: data
    }
}

export const updateCropObjectsFail = (error) => {
    return {
        type: actionTypes.CROPIMAGE_UPDATE_CROPOBJECTS_FAIL,
        payload: error
    }
}

export const setCropLoading = (data) => {
    return {
        type: actionTypes.CROPIMAGE_SET_LOADING,
        payload: data
    }
}

export const cropImageFromServer = ({ croppedObj, formatMessage }) => {
    const { parameters, clipid, mediafileid } = croppedObj;
    if (croppedObj && parameters && clipid)
        return (dispatch, getState) => {
            dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_START });
            let tags = getState().crop.cropObjects.currentTags || '';
            let sendObj = { clipid, parameters, tags };
            let mfId = 0;
            if (mediafileid) {
                sendObj.mediafileid = mediafileid;
                mfId = mediafileid;
            }
            console.log("LOGS: CROPPING cropImageFromServer clipid", clipid);
            console.log("LOGS: CROPPING cropImageFromServer mfId", mfId);
            console.log("LOGS: CROPPING cropImageFromServer parameters", parameters);
            console.log("LOGS: CROPPING cropImageFromServer tags", tags);
            if (window.flow.cropImage) {
                window.flow.cropImage(clipid, mfId, parameters, tags).then(res => {
                    console.log("LOGS: CROPPING cropImage res", res);
                    let msg = formatMessage({ id: `data.crop.createdmediafile` });
                    showIntlConfirmDialogWithCallback(msg, formatMessage, () => {
                        dispatch(actions.setInitCropObjects());
                    });
                    dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS });
                    setTimeout(() => dispatch(actions.updateMetadata("clip", clipid, {})), 2000);
                }).catch(err => console.log("CROPPING cropImageFromServer err", err))
            } else {
                window.flow.processCreate('imageconverter', 'imageconverter', sendObj).then(res => {
                    console.log("LOGS: CROPPING processCreate res", res);
                    let msg = formatMessage({ id: `data.crop.createdmediafile` });
                    showIntlConfirmDialogWithCallback(msg, formatMessage, () => {
                        dispatch(actions.setInitCropObjects());
                    });
                    dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS });
                    setTimeout(() => dispatch(actions.updateMetadata("clip", clipid, {})), 2000);
                }).catch(err => console.log("CROPPING cropImageFromServer err", err))
            }
        }
}

export async function importFile({ type, obj, localfile, activeObj, dispatch, formatMessage }) {
    try {
        let importObj = {};
        switch (type) {
            case CropTypes.NEW_CLIP:
                importObj = { metadata: obj.metadata };
                break;
            case CropTypes.MEDIA_FILE:
                importObj = { mode: "add", id: obj.masterClipId };
                break;
            case CropTypes.THUMBNAIL:
                importObj = { mode: 'addmainthumb', id: obj.masterClipId };
                break
            default:
                importObj = {};
                break;
        }
        console.log("LAMTEST importObj", importObj);
        let importRes = await window.flow.importFile(localfile, importObj);
        console.log("LAMTEST importRes", importRes);
        if (importRes && importRes.success) {
            if (type == CropTypes.NEW_CLIP && activeObj && activeObj.id) {
                dispatch(actions.addImageToProject({ activeObj, importRes, formatMessage }));
            }
            return { success: true }
        }

    } catch (error) {
        return { success: false, error }
    }
}

export const addImageToProject = ({ activeObj, importRes, formatMessage }) => {
    return (dispatch) => {
        window.flow.projectAddClip(activeObj.id, importRes.clipid)
            .then(res => {
                dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS });
                if (formatMessage) {
                    let msg = formatMessage({ id: `data.crop.addto${activeObj.type}` }) + ` ${activeObj.name}(${activeObj.id})`;
                    showIntlConfirmDialogWithCallback(msg, formatMessage, () => { });
                }
            })
            .catch(e => {
                console.log("LAMTEST addImageToProject Error", e);
            })
    }
}

export const importCropObjects = ({ type, obj, activeObj, formatMessage }) => {
    console.log("LAMTEST importCropObjects");
    if (type && obj && obj.file) {
        if (obj.metadata && obj.metadata.filename) {
            const newName = obj.metadata.filename + '.jpg';
            const newFile = new File([obj.file], newName, { type: obj.file.type });
            obj.file = newFile
            delete obj.metadata.filename;
        }
        return (dispatch) => {
            dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_START });
            setTimeout(() => {
                window.flow.uploadFile(obj.file).promise.then(res => {
                    let imptRes = importFile({ type, obj, localfile: res.localfile, activeObj, dispatch, formatMessage });
                    if (imptRes && obj.masterClipId && (type == CropTypes.MEDIA_FILE || type == CropTypes.THUMBNAIL)) {
                        dispatch(actions.updateMetadata("clip", obj.masterClipId, {}));
                    }
                    if (!(type == CropTypes.NEW_CLIP && activeObj && activeObj.id)) {
                        dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_SUCCESS });
                    }

                }).catch(err => {
                    dispatch({ type: actionTypes.CROPIMAGE_IMPORT_CROPOBJECTS_FAIL });
                })
            }, 2000);
        }
    }

}
